import * as Yup from 'yup';

export const schema = Yup.object().shape({
    rating: Yup.number().required('Pole wymagane'),
    email: Yup.string().when('rating', {
        is: (value) => value >= 1 && value <= 4,
        then: Yup.string().email('Niepoprawny adres e-mail').required('Pole wymagane'),
    }),
    message: Yup.string().when('rating', {
        is: (value) => value >= 1 && value <= 4,
        then: Yup.string().required('Pole wymagane'),
    }),
});
